import { config } from '@uhg-abyss/web/tools/config';
import { Icon } from '@uhg-abyss/web/ui/Icon';
import React from 'react';

import { Tier2Icon } from '../SnackCard/IconTier2';
import { CalmIcon } from './CalmIcon';
import { EmpireIcon } from './EmpireIcon';
import { GehaV2Icon } from './GehaV2Icon';
import { HealthAccessIcon } from './HealthAccessIcon';
import { HPHCLogoIcon } from './HPHCLogoIcon';
import { OptumLogoIcon } from './OptumLogoIcon';
import { UhcExchangeIcon } from './UhcExchangeIcon';
import { UhcLogoIcon } from './UhcLogoIcon';

const PSX_ASSET_CDN = `${config('CDN_BASE_URL')}/cdn/assets`;

const CUSTOM_ICON_COMPONENTS: Record<string, React.ComponentType<any>> = {
  tier_two: Tier2Icon,
  geha_brandingV2: GehaV2Icon,
  calm_logo: CalmIcon,
  uhc_exchange_custom_svg: UhcExchangeIcon,
  uhc_logo: UhcLogoIcon,
  optum_logo: OptumLogoIcon,
  empire_logo: EmpireIcon,
  health_access_optum_custom_svg: HealthAccessIcon,
  hphc_logo: HPHCLogoIcon,
};

type Props = {
  isScreenReadable?: boolean;
  icon: string;
  title?: string;
  [x: string]: any;
  color?: string;
};
export const PSXIcon = ({
  isScreenReadable,
  icon,
  title,
  color,
  ...props
}: Props) => {
  if (!icon) {
    return null;
  }

  // tier_two.svg is not reflecting on ui, so until issue is resolved as a workaround created a component for displaying the tier_two icon
  // and using it in conditional check.
  // created a defect for this to track -- DE988217: tier two icon is not displaying on ui even after adding svg and after generating metadata
  const CustomIconComponent = CUSTOM_ICON_COMPONENTS[icon];
  if (CustomIconComponent) {
    return <CustomIconComponent color={color} {...props} />;
  }

  return (
    <Icon
      {...props}
      icon={icon}
      spriteSheetId={icon}
      spriteSheetSrc={`${PSX_ASSET_CDN}/psx_icons.svg`}
      title={isScreenReadable ? title || icon : null}
    />
  );
};
